// Async
export const ASYNC_ACTION_START = 'ASYNC_ACTION_START'
export const ASYNC_ACTION_FINISH = 'ASYNC_ACTION_FINISH'
export const ASYNC_ACTION_ERROR = 'ASYNC_ACTION_ERROR'
export const ASYNC_ACTION_CLEAN_ERROR = 'ASYNC_ACTION_CLEAN_ERROR'

// User
export const OTP='OTP'
export const RESTART_OTP='RESTART_OTP'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'
export const LOGOUT = 'LOGOUT'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAIL = 'REGISTER_FAIL'
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'
export const FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL'
export const RESET_FORGOT_FLOW = 'RESET_FORGOT_FLOW'
export const CLEAN_REGISTRATION_SUCCESS = 'CLEAN_REGISTRATION_SUCCESS'
export const SET_AS_AUTHENTICATED = 'SET_AS_AUTHENTICATED'
export const SET_PROFILE_ITEMS = 'SET_PROFILE_ITEMS'
export const USER_DATA = 'USER_DATA'

// base
export const HOME = 'HOME'
export const SHIABUD_FORM='SHIABUD_FORM'
export const SHIABUD_SUBMITTED='SHIABUD_SUBMITTED'
export const TEMP_LIC='TEMP_LIC'
export const TEMP_LIC_REQ='TEMP_LIC_REQ'
export const UPLOAD_DOC='UPLOAD_DOC'
export const UPLOAD_DOC_ERROR='UPLOAD_DOC_ERROR'
export const SET_CURRENT_DOC='SET_CURRENT_DOC'
export const DELETE_CURRENT_DOC='DELETE_CURRENT_DOC'
export const UPLOAD_SIGNED_DOC='UPLOAD_SIGNED_DOC'
export const SIGNATURE_ERROR = 'SIGNATURE_ERROR'
export const SET_NOTIF='SET_NOTIF'

// Navbar
export const SET_NAVBAR_CURRENT_ITEM = 'SET_NAVBAR_CURRENT_ITEM'
export const SET_EXPPANDED_NAV = 'SET_EXPPANDED_NAV'
export const SET_ITEMS = 'SET_ITEMS'

// Modal
export const OPEN_MODAL = 'OPEN_LOGIN_MODAL'
export const CLOSE_MODAL = 'CLOSE_LOGIN_MODAL'